import logo from "./Logo.svg";
import noImagePlaceHolder from "./noImagePlaceHolder.png";

export const Images = {
  logo,
  noImagePlaceHolder
};
